<template>
    <div class="row mx-lg-auto">
        <div class="col-md-6 mx-lg-auto ">
            <div class="input-card mx-lg-auto">
                <div class="input-card-form">
                    <input type="text" v-model="response"  class="form-control text-center" placeholder="ejemplo@ejemplo.com" @change="ValidarRespuesta" @mouseleave="ValidarRespuesta" @keypress="ValidarRespuesta" @paste="ValidarRespuesta" v-on:keyup.enter="ValidarRespuesta"/>
                </div>
            </div>

            <div class="form-check mx-lg-auto" style="font-size:9pt; text-align: justify; padding-top:20px;" v-if="lopd == 'yes'">
                <input class="form-check-input" type="checkbox" v-if="checklopd" checked @click="checklopdClick()">
                <input class="form-check-input" type="checkbox" v-else @click="checklopdClick()">

                <label class="form-check-label">   
                    <p @click="checklopdClick()" v-if="insurance_name != ''">Tus datos son tratados por <strong>{{company_name}}</strong> y con el fin de facilitar la oferta y contrataci&oacute;n de productos y servicios de seguros adecuados a tus necesidades pueden ser cedidos a <span style="text-decoration: underline;"><strong>{{insurance_name}}</strong></span> y/o a aquellas compa&ntilde;&iacute;as aseguradoras con las que {{company_name}} tenga firmado un contrato de mediaci&oacute;n con sometimiento a la normativa vigente en materia de protecci&oacute;n de datos y seguridad de la infromaci&oacute;n. Puedes consultar m&aacute;s detalles sobre este tratamiento y c&oacute;mo ejercer tus derechos en nuestra Pol&iacute;tica de Privacidad.</p>
                    <p @click="checklopdClick()" v-else>Tus datos son tratados por <strong>{{company_name}}</strong> y con el fin de facilitar la oferta y contrataci&oacute;n de productos y servicios de seguros adecuados a tus necesidades pueden ser cedidos a aquellas compa&ntilde;&iacute;as aseguradoras con las que {{company_name}} tenga firmado un contrato de mediaci&oacute;n con sometimiento a la normativa vigente en materia de protecci&oacute;n de datos y seguridad de la infromaci&oacute;n. Puedes consultar m&aacute;s detalles sobre este tratamiento y c&oacute;mo ejercer tus derechos en nuestra Pol&iacute;tica de Privacidad.</p>
                </label>
            </div>
        </div>

    </div>
</template>

<script>


import ValidateEmail from "./Email/ValidateEmail.js"

export default {
  name: 'Email',
  props: {

      response: String,
      FormularioTag: String,
      idQuestion: Number,
      lopd: String

  },

  data: function(){

      return {

          checklopd: true,
          company_name: "ALGORITMICA",
          insurance_name: ""


      }

  },

  mounted: function(){

    this.checklopd = true;


    if (company_name) {

        this.company_name = company_name;

    }


    if (insurance_name) {

            this.insurance_name = insurance_name;
        

    }

  },

  methods: {

      ValidarRespuesta : function(){

        if (this.response != null)
        {
           
            var valido = ValidateEmail.validarEmail(this.response);

            if (valido == true)
            {

                if (this.lopd == "yes")
                {

                    if (this.checklopd == true)
                    {

                        var valido = true;

                    } else {

                        var valido = false;


                    }



                } else {


                    var valido = true;

                }


            }
            //var valido = true;

        } else {
            
            var valido = false;

        }


        if (valido == true)
        {

            let Mutation = {

                formulario: this.FormularioTag,
                question: this.idQuestion,
                validate: true,
                response: this.response
            };

            
            this.$store.commit('actualizarRespuestaFormulario', Mutation);    

        } else {

            let Mutation = {

                formulario: this.FormularioTag,
                question: this.idQuestion,
                validate: false,
                response: this.response
            };

            this.$store.commit('actualizarRespuestaFormulario', Mutation);    

        }

      },

      checklopdClick : function(){


        if (this.checklopd == true)
        {

            this.checklopd = false;

        } else {

            this.checklopd = true;

        }


      }


  }
}
</script>